import { ApplicationState } from 'src/store';
import { StandardAppConfig } from 'src/Components/Configuration/StandardAppConfig';
import { BusinessDisasterValidator } from '../BusinessDisaster/BusinessDisasterValidator';
import { ReactChild } from 'react';
import { PersonalDisasterValidator } from '../PersonalDisaster/PersonalDisasterValidator';

export type ErrorType = 'EligibilityCriteria' |
    'NotInList' |
    'Required' |
    'Rule' |
    'ValidAddress' |
    'ValueType';

export interface HasMessage {
    message: ReactChild;
    errorType?: ErrorType;
}

// Avoid name-clash with ErrorSummary component
export type ErrorSummaryType = Record<string, HasMessage>;

export const EligibilityPageProjectArchetypeValidator = (globalState: ApplicationState, productArchetype: string, appConfig: StandardAppConfig): ErrorSummaryType => {

    switch (productArchetype) {
        case 'personalDisaster': return PersonalDisasterValidator(globalState,appConfig);
        case 'businessDisaster': return BusinessDisasterValidator(globalState,appConfig);
        default: return {};
    }
};
